import AnimationClip from '../AnimationClip';
import { Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import ElementComponent from '../../../Component/UI/Element';
import Renderable from '../../../Component/Renderable';
import Point from '../../../Utility/Point';

export class ShowCropUnlock extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const element: ElementComponent = gameObject.getComponent(
            ElementComponent
        );
        const renderable: Renderable = gameObject.getComponent(Renderable);
        renderable.visible = true;

        element.anchors = [0, 0, 1, 1];
        element.scale = new Point(0, 0);

        const scaleTween = this.getTween(element.scale);
        scaleTween.to({ x: 1, y: 1 }, 500).easing(Easing.Quadratic.InOut);

        yield* this.startTween(scaleTween);
    }
}
